// extracted by mini-css-extract-plugin
module.exports = {"borderLeft":"FooterNavbar_borderLeft__C18GQ","borderNone":"FooterNavbar_borderNone___qTPE","item":"FooterNavbar_item__1_hDU"};